<template>
  <div class="app-layout" :class="{ 'sidebar-is-collapsed': sidebarCollapsed }">
    <div class="bg-glow glow-1"></div>
    <div class="bg-glow glow-2"></div>
    <AppSidebar
      :open="navigationOpen"
      :collapsed="sidebarCollapsed"
      @close="closeNavigation"
      @toggle-collapsed="toggleSidebarCollapsed"
    />
    <button
      v-if="navigationOpen"
      type="button"
      class="sidebar-backdrop"
      :aria-label="$t('navigation.close_menu')"
      @click="closeNavigation"
    ></button>
    <div class="main-content">
      <AppNavbar
        :navigation-open="navigationOpen"
        @toggle-navigation="toggleNavigation"
      />
      <router-view />
    </div>
  </div>
</template>
  
<script>
  import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
  import { useRoute } from 'vue-router'
  import AppSidebar from '@/components/App/AppSidebar.vue'
  import AppNavbar from '@/components/App/AppNavbar.vue'
  
  export default {
    components: {
      AppSidebar,
      AppNavbar,
    },
    setup() {
      const route = useRoute()
      const navigationOpen = ref(false)
      const sidebarCollapsed = ref(localStorage.getItem('sidebar-collapsed') === 'true')

      const closeNavigation = () => {
        navigationOpen.value = false
      }
      const toggleNavigation = () => {
        navigationOpen.value = !navigationOpen.value
      }
      const toggleSidebarCollapsed = () => {
        sidebarCollapsed.value = !sidebarCollapsed.value
        localStorage.setItem('sidebar-collapsed', String(sidebarCollapsed.value))
      }
      const onKeydown = (event) => {
        if (event.key === 'Escape') closeNavigation()
      }

      watch(() => route.fullPath, closeNavigation)
      watch(navigationOpen, (open) => {
        document.body.classList.toggle('navigation-open', open)
      })
      onMounted(() => window.addEventListener('keydown', onKeydown))
      onBeforeUnmount(() => {
        window.removeEventListener('keydown', onKeydown)
        document.body.classList.remove('navigation-open')
      })

      return {
        navigationOpen,
        sidebarCollapsed,
        closeNavigation,
        toggleSidebarCollapsed,
        toggleNavigation,
      }
    }
  }
</script>
